import { FormControl } from '@chakra-ui/react';
//import { Select } from 'chakra-react-select';
import { SelectPicker, TagPicker } from 'rsuite';
import React, { Component } from 'react';
import { fetchWithAuth } from '../../utils/apiHelpers';
import { connect } from 'react-redux';
import {
  setCurrency,
  setIntegration,
  setLocationData,
  setLocation,
} from '../../redux/slices/locationSlice';
import {
  setPeriodSwitcher,
  setPeriodData,
  setPeriodFrom,
  setPeriodTo,
  setCompanySwitcherActive,
  setDefaultDateValue,
} from '../../redux/slices/dateSlice';

//import { SelectPicker } from 'rsuite';

class MultiLocationDropDown extends Component {
  state = {
    locationData: [
      {
        label: undefined,
        value: undefined,
      },
    ],
    locationValue: [],
  };

  fetchLocations() {
    if (this.props.locationData.length === 0) {
      fetchWithAuth('/api/fetch_locations/', {
        method: 'POST',
      })
        .then(response => response.json())
        .then(data => {
          if (data.length > 0) {
            var dataNew = data.map(item => {
              return {
                label: item.ui_label,
                value: item.ui_label,
                currency: item.currency,
                ddl_value: item.ddl_value,
                period_length: item.period_length,
                // Capture location_id_id from API response
                locationId: item.location_id_id,
                // Extract integration id from ddl_value
                integrationId:
                  typeof item.ddl_value === 'string'
                    ? item.ddl_value.split('|')[1]
                    : null,
              };
            });

            this.setState({ locationData: dataNew });
            this.props.setLocationData(dataNew);
            this.props.setLocation(dataNew[0].value);
            this.props.setIntegration(dataNew[0]?.ddl_value.split('|')[1]);
            this.props.setCurrency(dataNew[0]?.currency);
            if (dataNew[0]?.ddl_value.split('|')[3].split('=')[1] === 'false') {
              this.props.setPeriodSwitcher(false);
            } else {
              this.props.setPeriodSwitcher(true);
            }
          }
        })
        .catch(err => console.error(err));
    }
    // No need to call fetchPeriod as it doesn't exist in this component
  }

  initializeSelection = locations => {
    if (
      locations &&
      locations.length === 1 &&
      locations[0] &&
      locations[0].value
    ) {
      const singleLocation = locations[0].value;
      this.setState({ locationValue: [singleLocation] });
      if (this.props.onChange) {
        this.props.onChange([singleLocation]); // Trigger API call in DateAnalysis
      }
    }
  };

  componentDidMount = async () => {
    if (!this.props.locationData || this.props.locationData.length === 0) {
      this.fetchLocations();
    } else {
      this.initializeSelection(this.props.locationData);
    }
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.locationData !== this.props.locationData &&
      this.props.locationData
    ) {
      this.initializeSelection(this.props.locationData);
    }
  }

  checkLocation = value => {
    console.log('checkLocation');
    console.log(value);
    if (!value || value[0] === undefined || value === 'location') {
      return false;
    } else {
      return true;
    }
  };
  render() {
    return (
      <FormControl minWidth={'150px'}>
        <TagPicker
          loading={
            !this.props.locationData ||
            !this.props.locationData[0] ||
            this.props.locationData[0].label === undefined ||
            this.props.dataLoading
          }
          data={this.props.locationData}
          value={this.props.locationValue}
          size="sm"
          //placeholder={this.props.locationData[0].label}
          //value={[this.props.locationData[0].label]}
          //style={{ width: '100%' }}
          block
          onChange={value => {
            this.setState({ locationValue: value });
            if (this.props.onChange) {
              this.props.onChange(value);
            }
          }}
          onClose={this.props.onClose}
          onClean={() => {
            this.setState({ locationValue: [] });
            if (this.props.onClean) {
              this.props.onClean();
            }
          }}
          onTagRemove={this.props.onTagRemove}
          style={{ overflowY: 'scroll', maxHeight: 30 }}
        />
      </FormControl>
    );
  }
}
const mapStateToProps = state => {
  return {
    dataLoading: state.dataFetch.dataLoading,
    locationData: state.locationSelectFormat.locationData,
    location: state.locationSelectFormat.location,
  };
};

const mapDispatchToProps = {
  setLocationData,
  setLocation,
  setIntegration,
  setCurrency,
  setPeriodSwitcher,
  setPeriodData,
  setPeriodFrom,
  setPeriodTo,
  setCompanySwitcherActive,
  setDefaultDateValue,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MultiLocationDropDown);
